import * as React from "react";
import Modal from "../misc/components/modal";
import { useAuth } from 'react-oidc-context';
import { useWebPortalLegacyClient } from "../misc/api/WebPortalTokenClient";

interface SessionExpiringModalProps {
    logoutRedirectUri: string;
    onClose: () => void;
}

declare const rootUrl: string;

export const SessionExpiringModal = ({ logoutRedirectUri, onClose }: SessionExpiringModalProps) => {
    const { signinSilent, signoutRedirect } = useAuth();
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const interval = setInterval(() => {
            legacyClient.LogSignInAuditTrail(true, "Inactivity");
            signoutRedirect({ post_logout_redirect_uri: `${rootUrl}${logoutRedirectUri}` });
        }, 60000);
        return () => clearInterval(interval);
    }, []);

    const continueSession = () => {
        signinSilent();
        onClose();
    }

    return (<Modal show={true} zIndex={3000}>
        <div className="modal-body">
            You're about to be signed out due to inactivity. Press continue to stay signed in.
        </div>
        <div className="modal-footer">
            <button className="btn btn-primary" onClick={() => continueSession()}>Continue</button>
        </div>
    </Modal>);
}
